import { useState } from 'react'
import { useFormikContext } from 'formik'
import { Button, FormControl, FormHelperText, Input, InputLabel, Typography } from '@mui/material'

import { HelperWrapper, ShowPassowrdIcon } from 'src/components'
import { ETranslationNs, IChangeUserPasswordFormProps } from 'src/types'

import { useStyles } from './styles'

const ChangePasswordForm = () => {
  const { errors, values, handleChange, isSubmitting } =
    useFormikContext<IChangeUserPasswordFormProps>()
  const classes = useStyles()
  const [showPassword, setShowPassword] = useState(false)

  const handleShowPassword = () => setShowPassword(!showPassword)

  return (
    <div className={classes.formWrapper}>
      <div className={classes.formInputsWrapper}>
        <Typography className={classes.title}>
          <HelperWrapper t="password-change-form-title" ns={ETranslationNs.UserProfile} />
        </Typography>
        <FormControl>
          <InputLabel htmlFor="oldPassword">
            <HelperWrapper ns={ETranslationNs.UserProfile} t="current-password-input-label" />*
          </InputLabel>
          <Input
            autoComplete="off"
            value={values.oldPassword}
            onChange={handleChange}
            name="oldPassword"
            id="oldPassword"
            type={showPassword ? 'text' : 'password'}
            endAdornment={
              <ShowPassowrdIcon onClick={handleShowPassword} showPassword={showPassword} />
            }
          />
          <FormHelperText>
            <Typography className={classes.warningText}>
              {errors.oldPassword && (
                <HelperWrapper ns={ETranslationNs.UserProfile} t={errors.oldPassword} />
              )}
            </Typography>{' '}
          </FormHelperText>
        </FormControl>
        <FormControl>
          <InputLabel htmlFor="newPassword">
            <HelperWrapper ns={ETranslationNs.UserProfile} t="new-password-input-label" />*
          </InputLabel>
          <Input
            autoComplete="off"
            value={values.newPassword}
            name="newPassword"
            id="newPassword"
            onChange={handleChange}
            type={showPassword ? 'text' : 'password'}
            endAdornment={
              <ShowPassowrdIcon onClick={handleShowPassword} showPassword={showPassword} />
            }
          />
          <FormHelperText>
            <Typography className={classes.warningText}>
              {errors.newPassword && (
                <HelperWrapper ns={ETranslationNs.UserProfile} t={errors.newPassword} />
              )}
            </Typography>{' '}
          </FormHelperText>
        </FormControl>
        <FormControl>
          <InputLabel htmlFor="newPasswordConfirm">
            <HelperWrapper ns={ETranslationNs.UserProfile} t="confirm-new-password-input-label" />*
          </InputLabel>
          <Input
            autoComplete="off"
            value={values.newPasswordConfirm}
            name="newPasswordConfirm"
            id="newPasswordConfirm"
            onChange={handleChange}
            type={showPassword ? 'text' : 'password'}
            endAdornment={
              <ShowPassowrdIcon onClick={handleShowPassword} showPassword={showPassword} />
            }
          />
          <FormHelperText>
            <Typography className={classes.warningText}>
              {errors.newPasswordConfirm && (
                <HelperWrapper ns={ETranslationNs.UserProfile} t={errors.newPasswordConfirm} />
              )}
            </Typography>
          </FormHelperText>
        </FormControl>
      </div>
      <Button disabled={isSubmitting} variant="contained" type="submit">
        <HelperWrapper ns={ETranslationNs.UserProfile} t="change-password-submit-button" />
      </Button>
    </div>
  )
}

export { ChangePasswordForm }
